// angular
import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
// enums
import { StagedInput } from '@app/shared/enums/staged-input.enum';

@Component({
  selector: 'pwj-staged-input',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: StagedInputComponent,
      multi: true,
    },
  ],
  templateUrl: './staged-input.component.html',
  styleUrl: './staged-input.component.scss',
})
export class StagedInputComponent implements ControlValueAccessor {
  public stageValueEnums = StagedInput;
  public stageValue!: StagedInput | '';

  // inputs
  label = input.required<string>();

  public propagateChange = (_: StagedInput | '') => {};
  public setStageValue(value: StagedInput) {
    if (this.stageValue === value) {
      switch (value) {
        case this.stageValueEnums.High: {
          this.propagateChange(this.stageValueEnums.Normal);
          this.stageValue = this.stageValueEnums.Normal;
          break;
        }
        case this.stageValueEnums.Normal: {
          this.propagateChange(this.stageValueEnums.Low);
          this.stageValue = this.stageValueEnums.Low;
          break;
        }
        case this.stageValueEnums.Low: {
          this.propagateChange('');
          this.stageValue = '';
          break;
        }
      }
    } else {
      this.propagateChange(value);
      this.stageValue = value;
    }
  }

  public writeValue(value: StagedInput): void {
    this.stageValue = value;
  }

  public registerOnChange(fn: () => void): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: () => void): void {}
}
